import ReactDOM from "react-dom/client";
import "./styles/config.css";
import "./styles/globals.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/main.route";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
